import React, { useState, useEffect } from "react";
import style from "./defaultSetting.module.scss";
import Switch from "../SelectionControls/Switch/Switch"
import RadioButton from "../SelectionControls/RadioButton/RadioButton"
import SimpleDropDown from "../Dropdown/SimpleDropDown/DropDown"
import Input from "../input/input";
import Button from "../Button/button"
import Skeleton from "./skeleton"
import toPersianNumber from "../../helpers/actions/toPersianNumber"
import numberWithCommas from "../../helpers/actions/numberWithCommas";
import { reactive, safePricing, hasIncreasePricePermission, strategy, variantByBox, outOfRangeStrategy, hasMaxPriceLimit } from "../../helpers/consts/variantEditModal"
import { GetChannelList, GetChannelDefaultSetting, SetChannelDefaultSetting } from "../../actions/APIcalls"
import toEnglishNumber from "../../helpers/actions/toEnglishNumber";

const DefaultSetting = (props) => {

    const [data, setData] = useState({
        channels: [],
        channelSettings: [],
        tab: 0,
        skeleton: true,
    })

    const [marginArray, setMarginArray] = useState([
        { name: "100", checked: false }, { name: "200", checked: false },
        { name: "300", checked: false }, { name: "400", checked: false },
        { name: "500", checked: false }, { name: "600", checked: false },
        { name: "700", checked: false }, { name: "800", checked: false },
        { name: "900", checked: false }, { name: "1000", checked: false },
        { name: "2000", checked: false }, { name: "5000", checked: false },
        { name: "10000", checked: false }, { name: "20000", checked: false },
        { name: "50000", checked: false }, { name: "100000", checked: false },
        { name: "500000", checked: false }, { name: "1000000", checked: false },
    ])

    const [roundnessDigits, setRoundnessDigits] = useState([
        { name: 2, checked: false },
        { name: 3, checked: false },
        { name: 4, checked: false },
        { name: 5, checked: false },
        { name: 6, checked: false }
    ])

    useEffect(async () => {
        await gettingChannelList()
        await getDefaultSettings()
    }, [])

    const gettingChannelList = async () => {
        let res = await GetChannelList()
        let tmp = data
        if (typeof res !== "undefined" && typeof res.data !== "undefined") {
            tmp.channels = res.data.channelList
        }
        setData({ ...tmp })
    }

    const getDefaultSettings = async () => {
        let ids = data.channels.map(el => el._id)
        let tmp = data
        tmp.skeleton = true;
        setData({ ...tmp })
        for (let index = 0; index < ids.length; index++) {
            let setting = await getSingleSetting(ids[index])
            if (typeof setting !== "undefined" && typeof setting.data !== "undefined" && setting.data.data) {
                let dummyObject = {
                    ...setting.data.data,
                    variantByBoxType: setting.data.data.isVariantBox ? 'variantBox' : 'productBox',
                    safePricing: setting.data.data.safePricing ? 'enable' : 'disable',
                    hasMaxPriceLimit: typeof setting.data.data.hasMaxPriceLimit != 'undefined' ? setting.data.data.hasMaxPriceLimit : false,
                    platformCosts: typeof setting.data.data.platformCosts != 'undefined' ? setting.data.data.platformCosts : false,
                    hasIncreasePricePermission: (setting.data.data.hasIncreasePricePermission == false ? 'off' : (setting.data.data.hasIncreasePricePermission == true ? 'maxPrice' : setting.data.data.hasIncreasePricePermission))
                }
                tmp.channelSettings.push(dummyObject)
            }
        }
        tmp.skeleton = false;
        setData({ ...tmp })
    }

    const getSingleSetting = async (channelId) => {
        let res = await GetChannelDefaultSetting({ channel_id: channelId })
        return res;
    }

    const handleSwitchButton = (e, val, tag) => {
        let tmp = data
        tmp.channelSettings[data.tab][tag] = !val
        setData({ ...tmp })
    }

    const radioHandeler = (e, val, tag, secondTag) => {
        let tmp = data
        if (tag == 'isVariantBox') {
            tmp.channelSettings[data.tab]['variantByBoxType'] = secondTag
            tmp.channelSettings[data.tab][tag] = secondTag == 'variantBox' ? true : false
        } else {
            tmp.channelSettings[data.tab][tag] = secondTag
        }
        setData({ ...tmp })
    }

    const handleDropdown = (tag, val) => {
        let tmp = data
        tmp.channelSettings[data.tab][tag] = val.name
        setData({ ...tmp })
    }

    const deleteDropdownOption = tag => {
        let tmp = data
        tmp.channelSettings[data.tab][tag] = 1000
        setData({ ...tmp })
    }

    const inputHandler = (tag, e) => {
        let tmp = data
        tmp.channelSettings[data.tab][tag] = Number(toEnglishNumber(e.target.value.toString().replaceAll(",", ""))).toFixed(0)
        setData({ ...tmp })
    }

    const confirmDefaultSetting = async () => {
        let totalTmp = data
        let tmp = data.channelSettings[data.tab]
        totalTmp.skeleton = true
        setData({ ...totalTmp })
        tmp = {
            ...data.channelSettings[data.tab],
            channelId: data.channels[data.tab]._id,
            safePricing: data.channelSettings[data.tab].safePricing == 'enable' ? true : false,
            pricingStrategy: data.channelSettings[data.tab].pricingStrategy == 'equalToBoxWinner' ? 'lowestPrice' : data.channelSettings[data.tab].pricingStrategy,
            sizeOfPriceIncrease: data.channelSettings[data.tab].pricingStrategy == 'equalToBoxWinner' ? 0 : data.channelSettings[data.tab].sizeOfPriceIncrease,
            ancillaryCosts: Number(data.channelSettings[data.tab].ancillaryCosts)
        }
        let res = await SetChannelDefaultSetting(tmp)
        let newSetting = await getSingleSetting(tmp.channelId)
        if (typeof newSetting !== "undefined" && typeof newSetting.data !== "undefined" && newSetting.data.data) {
            let dummyObject = {
                ...newSetting.data.data,
                variantByBoxType: newSetting.data.data.isVariantBox ? 'variantBox' : 'productBox',
                safePricing: newSetting.data.data.safePricing ? 'enable' : 'disable',
                hasMaxPriceLimit: typeof newSetting.data.data.hasMaxPriceLimit != 'undefined' ? newSetting.data.data.hasMaxPriceLimit : false,
            }
            totalTmp.channelSettings[data.tab] = dummyObject
        }
        totalTmp.skeleton = false
        setData({ ...totalTmp })
    }

    if (data.skeleton) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                <div className={style.header}>
                    <h1>تنظیمات پیش‌فرض</h1>
                </div>
                <div className={style.description}>
                    <div className={style.icon}>h</div>
                    <p>شما می‌توانید برای هر پنل فروش خود، تنظیمات پیش‌فرض مشخص کنید و این تنظیمات برای تنوع‌هایی از پنل انتخابی شما که تنظیمات پیش‌فرض را برای آنها مشخص نکرده‌اید، اعمال خواهد شد</p>
                </div>

                <div className={style.tabWrapper}>
                    <div className={style.tabs}>
                        {data.channels.length > 0 && data.channels.map((channelItem, channelIndex) => <div
                            key={`channelIndex_${channelIndex}`}
                            className={data.tab == channelIndex ? style.activeTab : style.tab}
                            onClick={() => setData({ ...data, tab: channelIndex })}
                        >
                            {channelItem.name}
                        </div>)}
                    </div>
                </div>

                {data.channelSettings[data.tab] && <div className={style.settings}>
                    <div className={style.settingWrapper}>
                        <p className={style.title}>وضعیت ربات</p>
                        <div className={style.itemWrapper}>
                            <Switch
                                value={typeof data.channelSettings[data.tab].salesStatus !== "undefined" && data.channelSettings[data.tab].salesStatus ? true : false}
                                indeterminate={false}
                                disabled={false}
                                tag='salesStatus'
                                onclick={handleSwitchButton}
                            />
                        </div>
                    </div>

                    <div className={style.settingWrapper}>
                        <p className={style.title}>رقابت</p>
                        <div className={style.itemWrapper}>
                            {variantByBox.map((item, index) => {
                                return <div className={style.radioWrapper} key={index}>
                                    <div className={style.RadioButton}>
                                        <RadioButton
                                            value={data.channelSettings[data.tab].variantByBoxType == item.value ? true : false}
                                            disabled={false}
                                            tag={"isVariantBox"}
                                            label={item.label}
                                            secondTag={item.value}
                                            onclick={radioHandeler}
                                            key={"variantByBoxType" + index}
                                        />
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>

                    <div className={style.settingWrapper}>
                        <p className={style.title}>پله تغییر قیمت</p>
                        <div className={style.itemWrapper}>
                            <SimpleDropDown
                                tag='sizeOfPriceIncrease'
                                value={data.channelSettings[data.tab].sizeOfPriceIncrease && toPersianNumber(numberWithCommas(data.channelSettings[data.tab].sizeOfPriceIncrease))}
                                dropdownList={marginArray}
                                hasSearchBox={false}
                                hasCheckbox={false}
                                handleSelect={handleDropdown}
                                deleteSelectedItems={deleteDropdownOption}
                                withRial={true}
                                withCommas={true}
                                errorMessage=''
                            />
                        </div>
                    </div>

                    <div className={style.settingWrapper}>
                        <p className={style.title}>هزینه‌های جانبی</p>
                        <div className={style.itemWrapper}>
                            <div className={style.inputWrapper}>
                                <Input
                                    type="text"
                                    disabled={false}
                                    placeholder="هزینه‌های جانبی"
                                    tag="ancillaryCosts"
                                    value={typeof data.channelSettings[data.tab].ancillaryCosts !== "undefined" ? numberWithCommas(data.channelSettings[data.tab].ancillaryCosts.toString()) : "0"}
                                    withRial={true}
                                    onchange={inputHandler}
                                    onblur={() => { }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={style.settingWrapper}>
                        <p className={style.title}>استراتژی</p>
                        <div className={style.itemWrapper}>
                            {strategy.map((item, index) => {
                                return <div className={style.radioWrapper} key={"stg" + index}>
                                    <div className={style.RadioButton}>
                                        <RadioButton
                                            value={data.channelSettings[data.tab].pricingStrategy === item.value ? true : false}
                                            disabled={false}
                                            tag={"pricingStrategy"}
                                            label={item.label}
                                            secondTag={item.value}
                                            onclick={radioHandeler}
                                        /></div>
                                </div>
                            })}
                        </div>
                    </div>

                    <div className={style.settingWrapper}>
                        <p className={style.title}>حفظ پله در افزایش قیمت</p>
                        <div className={style.itemWrapper}>
                            {hasMaxPriceLimit.map((item, index) => {
                                return <div className={style.radioWrapper} key={"hasMaxPriceLimit" + index}>
                                    <div className={style.RadioButton}>
                                        <RadioButton
                                            value={data.channelSettings[data.tab].hasMaxPriceLimit === item.value ? true : false}
                                            disabled={false}
                                            tag={"hasMaxPriceLimit"}
                                            label={item.label}
                                            secondTag={item.value}
                                            onclick={radioHandeler}
                                        /></div>
                                </div>
                            })}
                        </div>
                    </div>

                    <div className={style.settingWrapper}>
                        <p className={style.title}>فعال‌سازی مجدد</p>
                        <div className={style.itemWrapper}>
                            {reactive.map((item, index) => {
                                return <div className={style.radioWrapper} key={"reacrive" + index}>
                                    <div className={style.RadioButton}>
                                        <RadioButton
                                            value={data.channelSettings[data.tab].reactivation === item.value ? true : false}
                                            disabled={false}
                                            tag={"reactivation"}
                                            secondTag={item.value}
                                            label={item.label}
                                            onclick={radioHandeler}
                                        /></div>
                                </div>

                            })}
                        </div>
                    </div>

                    <div className={style.settingWrapper}>
                        <p className={style.title}>افزایش قیمت امن</p>
                        <div className={style.itemWrapper}>
                            {safePricing.map((item, index) => {
                                return <div className={style.radioWrapper} key={"safePricing" + index}>
                                    <div className={style.RadioButton}>
                                        <RadioButton
                                            value={data.channelSettings[data.tab].safePricing === item.value ? true : false}
                                            disabled={false}
                                            tag={"safePricing"}
                                            secondTag={item.value}
                                            label={item.label}
                                            onclick={radioHandeler}
                                        /></div>
                                </div>
                            })}
                        </div>
                    </div>

                    <div className={style.settingWrapper}>
                        <p className={style.title}>استراتژی کف قیمت</p>
                        <div className={style.itemWrapper}>
                            {hasIncreasePricePermission.map((item, index) => {
                                return <div className={style.radioWrapper} key={"hasIncreasePricePermission" + index}>
                                    <div className={style.RadioButton}>
                                        <RadioButton
                                            value={data.channelSettings[data.tab].hasIncreasePricePermission === item.value ? true : false}
                                            disabled={false}
                                            tag={"hasIncreasePricePermission"}
                                            secondTag={item.value}
                                            label={item.label}
                                            onclick={radioHandeler}
                                        /></div>
                                </div>

                            })}
                        </div>
                    </div>

                    <div className={style.settingWrapper}>
                        <p className={style.title}>استراتژی خارج از بازه</p>
                        <div className={style.itemWrapper}>
                            {outOfRangeStrategy.map((item, index) => {
                                return <div className={style.radioWrapper} key={"outOfRangeStrategy" + index}>
                                    <div className={style.RadioButton}>
                                        <RadioButton
                                            value={data.channelSettings[data.tab].outOfRangeStrategy === item.value ? true : false}
                                            disabled={false}
                                            tag={"outOfRangeStrategy"}
                                            secondTag={item.value}
                                            label={item.label}
                                            onclick={radioHandeler}
                                        /></div>
                                </div>

                            })}
                        </div>
                    </div>

                    <div className={style.settingWrapper}>
                        <p className={style.title}>ارقام رند</p>
                        <div className={style.itemWrapper}>
                            <SimpleDropDown
                                tag='roundnessDigits'
                                label='ارقام رند'
                                value={data.channelSettings[data.tab].roundnessDigits && toPersianNumber(numberWithCommas(data.channelSettings[data.tab].roundnessDigits))}
                                dropdownList={roundnessDigits}
                                hasSearchBox={false}
                                hasCheckbox={false}
                                handleSelect={handleDropdown}
                                deleteSelectedItems={deleteDropdownOption}
                                withRial={false}
                                withCommas={false}
                                errorMessage=''
                            />
                        </div>
                    </div>

                    <div className={style.settingWrapper}>
                        <p className={style.title}>درنظر گرفتن فروش اعتباری</p>
                        <div className={style.itemWrapper}>
                            <Switch
                                value={typeof data.channelSettings[data.tab].platformCosts !== "undefined" && data.channelSettings[data.tab].platformCosts ? true : false}
                                indeterminate={false}
                                disabled={false}
                                tag='platformCosts'
                                onclick={handleSwitchButton}
                            />
                        </div>
                    </div>


                    <div className={style.buttonWrapper}>
                        <Button
                            disabled={false}
                            tag={'confirmDefaultSetting'}
                            type="solid"
                            label='تایید'
                            onclick={confirmDefaultSetting}
                        />
                    </div>


                </div>}
            </div>
        )
    }
}

export default DefaultSetting;



